var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":this.block.label,"horizontal":""}},[_c('b-input',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }